import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_SUNLOCK_GET_LIST,
} from 'api/actionTypes';

export default async function getSunlocksList({ state, apiClient }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_SUNLOCK_GET_LIST,
    state: state,
    onSuccess(sunlocksList) {
      typeCheck('sunlocksList::Array', sunlocksList);
      state.set(['sunlocks', 'list'], sunlocksList);
      return sunlocksList;
    },
  });
}
